import { createContext } from "react";
import type { AppUserInfo } from "./AppUserInfo";

export const AppUserInfoUpdateContext = createContext<
  ((a: AppUserInfo) => void) | undefined
>(undefined);
